export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.error(error)
    // You can also send the error to a logging service here
    // for example: Sentry.captureException(error);
  }
  window.addEventListener('unhandledrejection', (event) => {
    console.error('Error:', event.reason)
  })
})
